<template>
  <v-container fluid class="pt-0">
    <v-card min-width="100%">
      <v-card-title>Добро пожаловать!</v-card-title>
    <v-card-text>
      <div class="mb-2">
        Полный прайс на доп модули 
        <a class="link" href="https://docs.google.com/spreadsheets/d/1VeRDGoFIILa2-m_MHqoEF6YZmdissKNM/edit?gid=1561515519#gid=1561515519" target="_blank">
          размещен тут.
        </a>
      </div>

      <p class="mb-0">
        Скидки на лицензии Carbis для сетевых клиентов
      </p>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">Количество объектов одного клиента</th>
              <th class="text-left">% Скидки</th>
            </tr>
          </thead>
          <tbody>
            <tr><td>1–5</td><td>0</td></tr>
            <tr><td>6–10</td><td>10</td></tr>
            <tr><td>11–20</td><td>15</td></tr>
            <tr><td>21–30</td><td>20</td></tr>
            <tr><td>31–40</td><td>25</td></tr>
            <tr><td>41–50</td><td>30</td></tr>
            <tr><td>51–60</td><td>35</td></tr>
            <tr><td>61–80</td><td>40</td></tr>
            <tr><td>81–100</td><td>45</td></tr>
            <tr><td>101 и более</td><td>50</td></tr>
          </tbody>
        </template>
      </v-simple-table>

      <div class="mt-4">
        Описание системы:
        <a class="link" href="https://wiki.carbis.ru/lic/lic" target="_blank">
          wiki.carbis.ru
        </a>
      </div>
    </v-card-text>
    </v-card>

    <v-card min-width="100%" class="mt-3">
      <v-card-title class="headline justify-space-between">
        Краткий отчет об окончании Лицензий на ближашую неделю
      </v-card-title>
      <v-data-table
        class="mb-3 mx-3"
        :search="search"
        :headers="headers"
        :items="licenses"
        :item-class="() => 'clickable-row'"
        sort-by="licExpires"
        no-data-text="Пусто"
        hide-default-footer
        :custom-sort="customSort"
        @click:row="editLicense"
        :loading="tableLoading"
        loading-text="Загрузка"
        :items-per-page="10"
      >
        <template v-slot:item.licExpires="{ item }">
          <span
            :class="{
              expired:
                new Date(new Date().toISOString().slice(0, 10)) >
                new Date(item.licExpires),
            }"
            >{{ new Date(item.licExpires).toLocaleDateString() }}</span
          >
        </template>
        <template v-slot:item.masterExpires="{ item }">
          <span
            :class="{
              expired:
                new Date(new Date().toISOString().slice(0, 10)) >
                new Date(item.masterExpires),
            }"
            >{{ new Date(item.masterExpires).toLocaleDateString() }}</span
          >
        </template>
        <template v-slot:item.toMaster="{ item }">
          <v-icon @click.stop="$router.push(`/masters/${item.masterId}`)">
            mdi-open-in-new
          </v-icon>
        </template>
        <template v-slot:top="{ pagination, options, updateOptions }">
          <v-data-footer
            :pagination="pagination"
            :options="options"
            @update:options="updateOptions"
            :items-per-page-options="[10, 50, 100, -1]"
            items-per-page-text="$vuetify.dataTable.itemsPerPageText"
          />
        </template>
        <template v-slot:item.updateTime="{ item }">
          <span>{{ formatUpdateTime(item.updateTime) }}</span>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import API from "@/axios/api";
import FormatDateTime from "@/utils/time.js";

export default {
  name: "Home",
  data() {
    return {
      page: 1,
      pageCount: 0,
      number: null,
      tableLoading: true,
      search: "",
      licenses: [],
      headers: [
        {
          text: "id",
          align: "start",
          value: "id",
        },
        {
          text: "Объект",
          align: "start",
          value: "objectName",
        },
        {
          text: "Дилер",
          align: "start",
          value: "dealerName",
        },
        {
          text: "Модуль ПО",
          align: "start",
          value: "moduleName",
        },
        {
          text: "Фичи",
          align: "start",
          value: "features",
        },
        {
          text: "Lic Date",
          align: "center",
          value: "licExpires",
        },
        {
          text: "Max Date",
          align: "center",
          value: "masterExpires",
        },
        {
          text: "Изменил",
          align: "center",
          value: "creatorName",
        },
        {
          text: "Дата последнего изменения",
          align: "center",
          value: "updateTime",
        },
        {
          text: "Мастер",
          align: "center",
          value: "toMaster",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    customSort(items, index, isDesc) {
      if (index[0] === "licExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.licExpires) > new Date(b.licExpires) ? 1 : -1;
          } else {
            return new Date(a.licExpires) > new Date(b.licExpires) ? -1 : 1;
          }
        });
      } else if (index[0] === "masterExpires") {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? 1
              : -1;
          } else {
            return new Date(a.masterExpires) > new Date(b.masterExpires)
              ? -1
              : 1;
          }
        });
      } else {
        items.sort((a, b) => {
          if (!isDesc[0]) {
            return a[index[0]] > b[index[0]] ? 1 : -1;
          } else {
            return a[index[0]] > b[index[0]] ? -1 : 1;
          }
        });
      }
      return items;
    },
    editLicense(license) {
      if (license.isDeleted) {
        this.$store.commit("showSnackbar", {
          color: "warning",
          text: "Лицензия удалена",
        });
      } else {
        this.$router.push("/licenses/" + license.id);
      }
    },
    async getWeekEndingLicenses() {
      await API.get("licenses/week")
        .then((response) => {
          console.log(response.data);
          this.licenses = response.data.licenses;
          // this.licenses.forEach(license => {
          //   license.licExpires = new Date(license.licExpires).toLocaleDateString();
          //   license.masterExpires = new Date(license.masterExpires).toLocaleDateString();
          // })
        })
        .catch((error) => {
          console.log(error);
        });
    },
    formatUpdateTime(time) {
      return FormatDateTime(time);
    },
  },
  activated() {
    this.$store.commit("setCrumbs", [{ text: "main", disabled: true }]);
  },
  created() {
    this.getWeekEndingLicenses().then(() => {
      this.tableLoading = false;
    });
  },
};
</script>

<style scoped>
.link {
  color: #1b8044;
  text-decoration: none;
}

.v-data-table .v-data-table__wrapper table tbody td{
  height: 24px !important;
}
</style>
